export const mutations = {
  ACCOUNT_RESET: "ACCOUNT_RESET",
  ACCOUNT_UPDATE_STATUS: "ACCOUNT_UPDATE_STATUS",
  ACCOUNT_UNLINK_STATUS: "ACCOUNT_UNLINK_STATUS",
  ACCOUNT_CHANGE_LANGUAGE: "ACCOUNT_CHANGE_LANGUAGE",
  ACCOUNT_CANCEL_CHANGE_LANGUAGE: "ACCOUNT_CANCEL_CHANGE_LANGUAGE",
  ACCOUNT_UPDATE_SHOP_INFO: "ACCOUNT_UPDATE_SHOP_INFO",
  ACCOUNT_ATTACH: "ACCOUNT_ATTACH",
  ACCOUNT_REMOVE_AGENCY_LOGO: "ACCOUNT_REMOVE_AGENCY_LOGO",
  ACCOUNT_UPDATE_GOOGLE_AUTH: "ACCOUNT_UPDATE_GOOGLE_AUTH",
  ACCOUNT_UPDATE_GETHELP_DATA: "ACCOUNT_UPDATE_GETHELP_DATA",
  UPDATE_LIMITATION_SUB_PAGE_ALERT: "UPDATE_LIMITATION_SUB_PAGE_ALERT",
  SET_INSTANT_SHOP_ID: "SET_INSTANT_SHOP_ID",
  SET_INSTANT_SHOP_TOKEN: "SET_INSTANT_SHOP_TOKEN"
  // ACCOUNT_FETCH_LANGUAGES: "ACCOUNT_FETCH_LANGUAGES",
};

export const actions = {
  ACCOUNT_UPDATE_SHOP_INFO: "accountUpdateShopInfo",
  ACCOUNT_UPDATE_STORE_INFO: "accountUpdateStoreInfo",
  ACCOUNT_WHO_AM_I: "accountWhoAmI",
  ACCOUNT_SETTINGS: "accountSettings",
  ACCOUNT_AGENCY_LOGIN: "accountAgencyLogin",
  ACCOUNT_UNLINK_AGENCY: "accountUnlinkagency",
  ACCOUNT_GET_GOOGLE_AUTH: "accountGetGoogleAuth",
  ACCOUNT_DISCONNECT_GOOGLE_ANALYTIC: "accountDisconnectGA",
  SYSTEM_SETTING_GETHELP: "sytemSettingGetHelp",
  ACCOUNT_CHANGE_LANGUAGE: "accountChangeLanguage",
  ACCOUNT_CANCEL_CHANGE_LANGUAGE: "accountCancelChangeLanguage",
  ACCOUNT_CLOSE_TRIAL_SURVEY: "accountCloseTrialSurvey",
  // ACCOUNT_FETCH_LANGUAGES: "fetchLanguages",
  ACCOUNT_UPDATE_SCRIPT_INJECTION: "accountUpdateCustomCode",
  CONNECT_GEMPAGES_V7: "connectGemPagesV7"
};
